import { render, staticRenderFns } from "./PriceFilters.vue?vue&type=template&id=4f00221c&"
import script from "./PriceFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f00221c')) {
      api.createRecord('4f00221c', component.options)
    } else {
      api.reload('4f00221c', component.options)
    }
    module.hot.accept("./PriceFilters.vue?vue&type=template&id=4f00221c&", function () {
      api.rerender('4f00221c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/PriceFilters/PriceFilters.vue"
export default component.exports